module.exports = __webpack_public_path__ + "img/contentImg2.b7d36cc5.png";